import { RouteConfig } from "vue-router";

const HomeRoute: Array<RouteConfig> = [
  {
    path: "/",
    component: () => import("@/views/ap/login/Login.vue")
   /*把default畫面改成Login*/
  }
];

export { HomeRoute };
